import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getPurchaseRequests = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching purchase requests:", error);
    throw error;
  }
};

// Helper function to clean identity column ID fields from payload
const cleanIdentityColumns = (data) => {
  if (!data || typeof data !== 'object') return data;
  
  // Create a deep copy to avoid mutating the original
  const cleaned = Array.isArray(data) ? [...data] : { ...data };
  
  // List of identity column patterns to clean
  const identityColumnPatterns = [
    'PurchaseRequest_Id',
    'PurchaseRequestDet_Id',
    'PurchaseRequestTaxDet_Id',
    'purchaseRequestTaxDet_Id' // Lowercase variant
  ];
  
  // Clean top-level identity columns
  identityColumnPatterns.forEach(pattern => {
    if (cleaned[pattern] !== undefined && (cleaned[pattern] === 0 || cleaned[pattern] === null)) {
      delete cleaned[pattern];
    }
  });
  
  // Recursively clean nested objects (Details, TaxDetails)
  if (cleaned.Details && Array.isArray(cleaned.Details)) {
    cleaned.Details = cleaned.Details.map(detail => {
      const cleanedDetail = { ...detail };
      identityColumnPatterns.forEach(pattern => {
        if (cleanedDetail[pattern] !== undefined && (cleanedDetail[pattern] === 0 || cleanedDetail[pattern] === null)) {
          delete cleanedDetail[pattern];
        }
      });
      return cleanedDetail;
    });
  }
  
  if (cleaned.TaxDetails && Array.isArray(cleaned.TaxDetails)) {
    cleaned.TaxDetails = cleaned.TaxDetails.map(tax => {
      const cleanedTax = { ...tax };
      if (cleanedTax.PurchaseRequestTaxDet_Id !== undefined && (cleanedTax.PurchaseRequestTaxDet_Id === 0 || cleanedTax.PurchaseRequestTaxDet_Id === null)) {
        delete cleanedTax.PurchaseRequestTaxDet_Id;
      }
      if (cleanedTax.purchaseRequestTaxDet_Id !== undefined && (cleanedTax.purchaseRequestTaxDet_Id === 0 || cleanedTax.purchaseRequestTaxDet_Id === null)) {
        delete cleanedTax.purchaseRequestTaxDet_Id;
      }
      return cleanedTax;
    });
  }
  
  return cleaned;
};

export const savePurchaseRequest = async (purchaseRequest) => {
  // Clean identity column ID fields before sending to backend
  const cleanedPayload = cleanIdentityColumns(purchaseRequest);
  
  const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/save`, cleanedPayload, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const getNextOrderNo = async (businessId) => {
  try {
    const payload = {
      Business_Id: businessId
    };
    
    const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/get-next-order-no`, payload, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error getting next order number:", error);
    throw error;
  }
};

export const markPurchaseRequestAsReceived = async (purchaseRequestId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/mark-as-received`, {
      PurchaseRequest_Id: purchaseRequestId
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error marking purchase request as received:", error);
    throw error;
  }
};

// API to export purchase request summary to Excel
export const exportPurchaseRequestSummaryToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/export-purchase-request-summary-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const fromDateStr = filter.From_Date ? new Date(filter.From_Date).toISOString().slice(0,10).replace(/-/g, '') : 'All';
    const toDateStr = filter.To_Date ? new Date(filter.To_Date).toISOString().slice(0,10).replace(/-/g, '') : 'All';
    link.setAttribute('download', `PurchaseRequestSummary_${fromDateStr}_to_${toDateStr}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting purchase request summary:", error);
    throw error;
  }
};

// API to export purchase request details to Excel
export const exportPurchaseRequestDetailsToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/export-purchase-request-details-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const fromDateStr = filter.From_Date ? new Date(filter.From_Date).toISOString().slice(0,10).replace(/-/g, '') : 'All';
    const toDateStr = filter.To_Date ? new Date(filter.To_Date).toISOString().slice(0,10).replace(/-/g, '') : 'All';
    const purchaseRequestIdStr = filter.PurchaseRequest_Id ? filter.PurchaseRequest_Id.toString() : 'All';
    link.setAttribute('download', `PurchaseRequestDetails_${purchaseRequestIdStr}_${fromDateStr}_to_${toDateStr}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting purchase request details:", error);
    throw error;
  }
};


